<template>
	<VueApexChart
		v-if="chartOptions"
		class="app-chart-heat-map"
		:class="{ 'live' : autoUpdate }"
		ref="chart"
		height="100%"
		width="100%"
		type="heatmap"
		:options="chartOptions"
		:series="series"
	/>
</template>

<script>
export default {
	props: {
		title: [String, Array],
		tickAmount: {
			type: Number,
			default: 5
		},

		autoUpdate: {
			type: Boolean,
			default: false
		},
		series: {
			type: Array,
			default: () => [
				{
					name: '',
					data: [
						{
							x: '1',
							y: 0
						},
						{
							x: '2',
							y: 0
						},
						{
							x: '3',
							y: 29
						},
						{
							x: '4',
							y: 39
						},
						{
							x: '5',
							y: 0
						},
						{
							x: '6',
							y: 0
						},
						{
							x: '7',
							y: 0
						},
						{
							x: '8',
							y: 0
						},
						{
							x: '9',
							y: 0
						},
						{
							x: '10',
							y: 0
						}
					]
				},
				{
					name: '',
					data: [
						{
							x: '1',
							y: 99
						},
						{
							x: '2',
							y: 89
						},
						{
							x: '3',
							y: 79
						},
						{
							x: '4',
							y: 69
						},
						{
							x: '5',
							y: 59
						},
						{
							x: '6',
							y: 49
						},
						{
							x: '7',
							y: 39
						},
						{
							x: '8',
							y: 29
						},
						{
							x: '9',
							y: 19
						},
						{
							x: '10',
							y: 9
						}
					]
				},
				{
					name: '',
					data: [
						{
							x: '1',
							y: 0
						},
						{
							x: '2',
							y: 0
						},
						{
							x: '3',
							y: 29
						},
						{
							x: '4',
							y: 39
						},
						{
							x: '5',
							y: 49
						},
						{
							x: '6',
							y: 0
						},
						{
							x: '7',
							y: 0
						},
						{
							x: '8',
							y: 0
						},
						{
							x: '9',
							y: 0
						},
						{
							x: '10',
							y: 5
						}
					]
				},
				{
					name: '',
					data: [
						{
							x: '1',
							y: 0
						},
						{
							x: '2',
							y: 0
						},
						{
							x: '3',
							y: 0
						},
						{
							x: '4',
							y: 23
						},
						{
							x: '5',
							y: 0
						},
						{
							x: '6',
							y: 0
						},
						{
							x: '7',
							y: 0
						},
						{
							x: '8',
							y: 0
						},
						{
							x: '9',
							y: 0
						},
						{
							x: '10',
							y: 0
						}
					]
				}
			]
		},

		noData: {
			type: String,
			default: 'No Data'
		}
	},

	created () {
		this.$watch(vm => [
			vm.autoUpdate,
			vm.title,
			vm.noData
		], () => {
			this.init()
		})

		this.init()
	},

	data () {
		return {
			chartOptions: null
		}
	},

	methods: {
		init () {
			this.chartOptions = {
				chart: {
					height: 500,
					type: 'heatmap',
					toolbar: {
						show: false
					},
					animations: {
						easing: 'linear',
						speed: 500,
						animateGradually: { delay: 500 },
						dynamicAnimation: { speed: 500 }
					}
				},
				plotOptions: {
					heatmap: {
						radius: 2,
						enableShades: true,
						shadeIntensity: 0.5,
						reverseNegativeShade: true,
						distributed: false,
						useFillColorAsStroke: false
					}
				},
				dataLabels: {
					enabled: false
				},
				colors: ['#18666D']
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.app-chart-heat-map {
	text-transform: capitalize;
	&.live { pointer-events: none; }
}
</style>



// WEBPACK FOOTER //
// src/components/app-components/AppHeatMap.vue